(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/components/intelligent-ask/learn-more/global.components.intelligent-ask', '<div class="iaa-learn-more">\n' + '  <h5>{{ $ctrl.header}}</h5>\n' + '  <p>{{ $ctrl.description}}</p>\n' + '  <a href="{{ $ctrl.href}}" target="_blank">Learn more</a>\n' + '</div>\n' + '');
}]);
})();